var map = {
	"./": 1365,
	"./Clutch": 2701,
	"./Clutch.js": 2701,
	"./NewUi": 2702,
	"./NewUi.js": 2702,
	"./OldUi": 2703,
	"./OldUi.js": 2703,
	"./index": 1365,
	"./index.js": 1365,
	"./style": 860,
	"./style.js": 860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4247;